import { styled, Grid } from '@mui/material';
import React from 'react';
import { WIDGET_SPACE, TABLET_SCREEN_SIZE, WIDGET_SPACE_HALF, TABLET_HORIZONTAL_PADDING, MOBILE_SCREEN_SIZE, MOBILE_HORIZONTAL_PADDING, WIDGET_MEDIA_BORDER_RADIUS, DESKTOP_SCREEN_SIZE, DESKTOP_HORIZONTAL_PADDING } from '../../utils/constants/Constants.js';
import { GenericContainer } from '../components/GenericContainer.js';

var _a;
var FeaturesContainer = styled(GenericContainer, {
    shouldForwardProp: function (prop) { return !['fullWidth'].includes(prop.toString()); },
})(function (_a) {
    var _b;
    var _c = _a.fullWidth, fullWidth = _c === void 0 ? false : _c, theme = _a.theme;
    return (_b = {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: WIDGET_SPACE,
            paddingBottom: WIDGET_SPACE,
            paddingLeft: fullWidth ? 0 : '5%',
            paddingRight: fullWidth ? 0 : '5%',
            boxSizing: 'border-box',
            color: theme.palette.primary.main
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            backgroundColor: '#fff',
            padding: "".concat(WIDGET_SPACE_HALF, "px ").concat(TABLET_HORIZONTAL_PADDING, "px"),
        },
        _b["@media screen and (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
            backgroundColor: '#fff',
            padding: "".concat(WIDGET_SPACE_HALF, "px ").concat(MOBILE_HORIZONTAL_PADDING, "px"),
        },
        _b);
});
var Container = styled(Grid)((_a = {
        maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
        flexDirection: 'row',
        justifyContent: 'space-around',
        gap: 10
    },
    _a["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {},
    _a));
var SingleFeatureContainer = styled(Grid)({
    minWidth: 100,
    maxWidth: 172,
    flexDirection: 'column',
    alignItems: 'center',
    '.img': {
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        width: 100,
        height: 100,
        borderRadius: WIDGET_MEDIA_BORDER_RADIUS,
    },
    '.title': {
        fontSize: 20,
        fontWeight: 500,
        marginTop: 15,
        textAlign: 'center',
    },
});
var SingleFeature = function (_a) {
    var feature = _a.feature;
    return (React.createElement(SingleFeatureContainer, { container: true },
        (feature === null || feature === void 0 ? void 0 : feature.image) && React.createElement("div", { className: "img", style: { backgroundImage: "url(".concat(feature === null || feature === void 0 ? void 0 : feature.image, ")") } }),
        (feature === null || feature === void 0 ? void 0 : feature.title) && React.createElement("div", { className: "title" }, feature.title)));
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var FiveShortFeatures = function (_a) {
    var _b;
    var items = _a.items, page = _a.page;
    var fullWidth = !!((_b = page === null || page === void 0 ? void 0 : page.containerConfigOverride) === null || _b === void 0 ? void 0 : _b.width);
    return (React.createElement(FeaturesContainer, { fullWidth: fullWidth },
        React.createElement(Container, { container: true }, items === null || items === void 0 ? void 0 : items.map(function (item, idx) {
            return React.createElement(SingleFeature, { key: idx, feature: item });
        }))));
};

export { FiveShortFeatures };
//# sourceMappingURL=index.js.map
